<template>
  <div >
    <!-- <div>

      <md-button class="md-just-icon md-round md-danger"  @click="newClient">
        <md-icon>add</md-icon>
      </md-button>
    </div> -->

   <md-card v-for="client in clients" :key="client._id" >
      <md-card-header>

          <router-link :to="{path:'/client?id='+client._id}" >
        <div class="md-title" >

              <span>  {{client.name}} </span>

        </div>
          </router-link>
      </md-card-header>

      <md-card-actions>
        <md-button   :data-clipboard-text="client.v3.ip" class="md-just-icon md-round clipboard" title="copiar ip" >
          <md-icon >more_horiz</md-icon>
         
        </md-button>
        <md-button   :data-clipboard-text="client.v3.ip +':' +client.v3.webPort" class="md-just-icon md-round clipboard" title="copiar puerto web" >
          <md-icon >exposure_plus_1</md-icon>        
         
        </md-button>
        <md-button  :data-clipboard-text="client.v3.ip +':' +client.v3.nodePort" class="md-just-icon md-round clipboard" title="copiar puerto node" >
          <md-icon >exposure_plus_2</md-icon>
         
        </md-button>

          <a :href="'http://'+client.v3.url" target="_blank" >
        <md-button  :data-clipboard-text="client.v3.url" class="md-just-icon md-round clipboard" title="ir al sitio" >
          <md-icon >insert_link</md-icon>
          
        </md-button>

          </a>
      </md-card-actions>
   </md-card>


  </div>
</template>
<script>
import axios from "axios";
import api from "../../../lib/api.js";
import { mapMutations } from "vuex";
export default {
  name: "Clients",
  components: {},
  data() {
    return {
      clients: []
    };
  },
  created() {
    axios(`${api()}/clients`)
      .then(res => {
        this.clients = res.data.docs;
      })
      .catch(err => {
        console.warn(err);
      });
  },
  computed: {},
  methods: {
    ...mapMutations({
      clear: "clients/clear"
    }),
    newClient() {
      this.clear();
      this.$router.push("/client");
    }
  }
};
</script>
<style scoped>
.md-card.card-inline {
  width: 600px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}
.md-button.md-just-icon {
  margin-left: 5px;
}
.hide {
  display: none;
}
.inputButton {
  color: inherit;
  background: transparent;
  border: none;
  cursor: pointer !important;
}
.md-field.hideField {
  opacity: 0;
  margin-left: -9999;
}
.md-title {
  color: black;
}
</style>
